import { Outlet } from 'react-router';
import { openConsentDoc } from '@/entities/consent';
import { useLogout } from '@/features/logout';
import {
  ContentColumn,
  ScreenShell,
  StandaloneFooter,
  StandaloneHeader,
  type WidthVariant,
} from '@/shared/ui';

interface StandaloneLayoutProps {
  /** 헤더·본문·푸터 공통 폭. 미지정 시 `ContentColumn` 기본('sm'). */
  width?: WidthVariant;
  /** 헤더 폭 override — 주어지면 `width` 보다 우선. */
  headerWidth?: WidthVariant;
  /** 본문 폭 override — 주어지면 `width` 보다 우선. */
  contentWidth?: WidthVariant;
  /** 푸터 폭 override — 주어지면 `width` 보다 우선. */
  footerWidth?: WidthVariant;
}
/**
 * 인증·구독 공통 셸. 표현(header·footer)은 shared/ui, 여기선 합성 + logout 배선만.
 * 폭은 `width` 공통값을 part 별 override(`headerWidth`·`contentWidth`·`footerWidth`)가 덮어쓴다.
 */
export function StandaloneLayout({
  width,
  headerWidth,
  contentWidth,
  footerWidth,
}: StandaloneLayoutProps) {
  const { logout, canLogout } = useLogout();
  return (
    <ScreenShell>
      <StandaloneHeader width={headerWidth ?? width} />
      <ContentColumn as="main" width={contentWidth ?? width} className="flex-1">
        <Outlet />
      </ContentColumn>
      <StandaloneFooter
        width={footerWidth ?? width}
        onLogout={canLogout ? logout : undefined}
        onOpenConsentDoc={openConsentDoc}
      />
    </ScreenShell>
  );
}

/**
 * 라우트 `element` 용 팩토리 — 폭 props 를 바인딩한 StandaloneLayout 엘리먼트를 만든다.
 * 라우트 파일(`.ts`)은 JSX 를 못 쓰므로 엘리먼트 생성을 이 `.tsx` 에 둔다.
 * `Component:` 는 props 를 못 받으니 라우트는 `element: standaloneLayout({ width: 'sm' })` 로 받는다.
 */
export function standaloneLayout(props: StandaloneLayoutProps = {}) {
  return <StandaloneLayout {...props} />;
}
